import "regenerator-runtime/runtime";
import _asyncToGenerator from "E:/project/pc/gzqx-byyj-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import http from "@/api/http";
import axios from "axios";
import { getConfigProjectId } from "./service-localstorage";
var _process$env = process.env,
    LOCAL_URL = _process$env.VUE_APP_GLOBAL_CONFIG,
    MENU_PATH = _process$env.VUE_APP_MENU_CONFIG,
    NODE_ENV = _process$env.NODE_ENV;
export default {
  GetAreaLineList: function () {
    var _GetAreaLineList = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var id, random, res;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              id = getConfigProjectId();
              random = new Date().getTime();

              if (!(NODE_ENV === "production")) {
                _context.next = 8;
                break;
              }

              _context.next = 5;
              return http.getStaticData("".concat(LOCAL_URL, "arealine/").concat(id, ".json?random=").concat(random));

            case 5:
              res = _context.sent;
              _context.next = 11;
              break;

            case 8:
              _context.next = 10;
              return axios.get("".concat(LOCAL_URL, "arealine/").concat(id, ".json?random=").concat(random));

            case 10:
              res = _context.sent;

            case 11:
              return _context.abrupt("return", res.data);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function GetAreaLineList() {
      return _GetAreaLineList.apply(this, arguments);
    }

    return GetAreaLineList;
  }(),
  GetProjectConfig: function () {
    var _GetProjectConfig = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(projectId, env) {
      var id, random, res;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (env) MENU_PATH = '';
              id = getConfigProjectId();
              random = new Date().getTime();

              if (!(NODE_ENV === "production")) {
                _context2.next = 9;
                break;
              }

              _context2.next = 6;
              return http.getStaticData("".concat(LOCAL_URL).concat(MENU_PATH, "menu/").concat(id, ".json?random=").concat(random));

            case 6:
              res = _context2.sent;
              _context2.next = 12;
              break;

            case 9:
              _context2.next = 11;
              return axios.get("".concat(LOCAL_URL).concat(MENU_PATH, "menu/").concat(id, ".json?random=").concat(random));

            case 11:
              res = _context2.sent;

            case 12:
              return _context2.abrupt("return", res.data);

            case 13:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    function GetProjectConfig(_x, _x2) {
      return _GetProjectConfig.apply(this, arguments);
    }

    return GetProjectConfig;
  }(),
  GetAlarmCityList: function () {
    var _GetAlarmCityList = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var id, random, res;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              id = getConfigProjectId();
              random = new Date().getTime();

              if (!(NODE_ENV === "production")) {
                _context3.next = 8;
                break;
              }

              _context3.next = 5;
              return http.getStaticData("".concat(LOCAL_URL, "alarm/").concat(id, ".json?random=").concat(random));

            case 5:
              res = _context3.sent;
              _context3.next = 11;
              break;

            case 8:
              _context3.next = 10;
              return axios.get("".concat(LOCAL_URL, "alarm/").concat(id, ".json?random=").concat(random));

            case 10:
              res = _context3.sent;

            case 11:
              return _context3.abrupt("return", res.data);

            case 12:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    function GetAlarmCityList() {
      return _GetAlarmCityList.apply(this, arguments);
    }

    return GetAlarmCityList;
  }(),
  GetBorderLineList: function () {
    var _GetBorderLineList = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      var id, random, res;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              id = getConfigProjectId();
              random = new Date().getTime();

              if (!(NODE_ENV === "production")) {
                _context4.next = 8;
                break;
              }

              _context4.next = 5;
              return http.getStaticData("".concat(LOCAL_URL, "borderline/").concat(id, ".json?random=").concat(random));

            case 5:
              res = _context4.sent;
              _context4.next = 11;
              break;

            case 8:
              _context4.next = 10;
              return axios.get("".concat(LOCAL_URL, "borderline/").concat(id, ".json?random=").concat(random));

            case 10:
              res = _context4.sent;

            case 11:
              return _context4.abrupt("return", res.data);

            case 12:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    function GetBorderLineList() {
      return _GetBorderLineList.apply(this, arguments);
    }

    return GetBorderLineList;
  }(),
  // 获取船舶配置
  getShipsData: function () {
    var _getShipsData = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
      var id, r, res;
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              id = getConfigProjectId();
              r = new Date().getTime();
              _context5.prev = 2;

              if (!(NODE_ENV === "production")) {
                _context5.next = 9;
                break;
              }

              _context5.next = 6;
              return http.getStaticData("".concat(LOCAL_URL, "ships/").concat(id, ".json?random=").concat(r));

            case 6:
              res = _context5.sent;
              _context5.next = 12;
              break;

            case 9:
              _context5.next = 11;
              return axios.get("".concat(LOCAL_URL, "ships/").concat(id, ".json?random=").concat(r));

            case 11:
              res = _context5.sent;

            case 12:
              return _context5.abrupt("return", res.data);

            case 15:
              _context5.prev = 15;
              _context5.t0 = _context5["catch"](2);
              return _context5.abrupt("return", false);

            case 18:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[2, 15]]);
    }));

    function getShipsData() {
      return _getShipsData.apply(this, arguments);
    }

    return getShipsData;
  }()
};